import { render, staticRenderFns } from "./ExcluindoDuplicidade.vue?vue&type=template&id=18bce6a4"
import script from "./ExcluindoDuplicidade.vue?vue&type=script&lang=js"
export * from "./ExcluindoDuplicidade.vue?vue&type=script&lang=js"
import style0 from "./ExcluindoDuplicidade.vue?vue&type=style&index=0&id=18bce6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports